import { z } from 'zod';

/** Width over height of the bottle area on a catalogue card; framed images are rendered at this shape. */
export const CARD_IMAGE_ASPECT = 200 / 258;

/**
 * An editor's framing of a stored original. Zoom 1 fits the whole picture inside the card frame; above 1
 * crops in, below 1 leaves blank margin. cx and cy are the frame's centre as fractions of the original.
 */
export const imageCropSchema = z.object({
  zoom: z.number().min(0.5).max(5),
  cx: z.number().min(-0.5).max(1.5),
  cy: z.number().min(-0.5).max(1.5),
});
export type ImageCrop = z.infer<typeof imageCropSchema>;
export const DEFAULT_CROP: ImageCrop = { zoom: 1, cx: 0.5, cy: 0.5 };

/** The framed region in the original's pixels. It may extend beyond the picture, which renders as blank margin. */
export function cropRect(width: number, height: number, crop: ImageCrop) {
  const fitsWidth = width / height > CARD_IMAGE_ASPECT;
  const w = fitsWidth ? width / crop.zoom : (height / crop.zoom) * CARD_IMAGE_ASPECT;
  const h = w / CARD_IMAGE_ASPECT;
  return { left: crop.cx * width - w / 2, top: crop.cy * height - h / 2, width: w, height: h };
}
